import { IOnInit } from "angular";
import { ColDef } from "../../../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../../records/server/serverUtility";
import { MachineConfigurationGateway } from "../../../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../../../models/progressiveDefinition";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../../../records/views/recordGridView";
import { vsObjectName } from "../../../../../config/machineConfiguration";
import { RecordDataSource } from "../../../../../../../records/grids";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../../../shared/machineConfigurationCellClassService";

const gridId = Symbol("main.machines.progressives.detail.machines.edit");

export class ProgressivesDetailMachinesEditComponentController
  implements IOnInit
{
  static $inject = [
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    RecordGridViewServiceName,
    MachineConfigurationCellClassServiceName,
  ];

  /* bindings */
  readonly progressiveDefinition!: ProgressiveDefinition;
  readonly progressiveMachineConfigurations!: MachineConfigurationGateway[];
  initialSelectedIds: number[] = [];
  /* end bindings */

  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultSort: string;
  readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
  };

  progressiveConfigurationsOnly: boolean = true;

  constructor(
    gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly serverUtility: ServerUtility,
    recordGridViewService: RecordGridViewService,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {
    const gridConfiguration =
      recordGridViewService.getGridConfiguration(vsObjectName)!;

    this.gridDataSource = gridConfiguration.gridDataSource!;
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = this.getColumns(gridConfiguration);
    this.defaultSort = gridConfiguration.defaultSort!;
  }

  getColumns(gridConfiguration: GridConfiguration): ColDef[] {
    const columns = [
      this.columnDefinitionService.getSelectColDef(),
      ...(gridConfiguration.columns ?? []),
    ];

    this.machineConfigurationCellClassService.styleColumns(columns, true);

    return columns;
  }

  $onInit(): void {
    this.initialSelectedIds = this.progressiveMachineConfigurations.map(
      (mc) => mc.Id
    );
    this.progressiveConfigurationsOnlyChanged(
      this.progressiveConfigurationsOnly
    );
  }

  progressiveConfigurationsOnlyChanged(progressiveConfigurationsOnly: boolean) {
    this.defaultQuery.ProgressiveDefinitionId = progressiveConfigurationsOnly
      ? this.progressiveDefinition.Id
      : undefined;
  }

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  gridSelectionChanged(args: {
    data: MachineConfigurationGateway;
    selected: boolean;
    gridSelection: MachineConfigurationGateway[];
  }) {
    const machineConfigurationId = args.data.Id;
    const progressiveDefinitionId = args.selected
      ? this.progressiveDefinition.Id
      : undefined;
    this.serverUtility.sendApiRequest({
      method: "PUT",
      url: `/api/machines/MachineConfiguration/${machineConfigurationId}/ProgressiveDefinitionId`,
      data: {
        ProgressiveDefinitionId: progressiveDefinitionId,
      },
    });
  }
}
